export default "__VITE_ASSET__DEOVyBpq__"